import { apiRequest } from '@/utils/api-request';

export type CollectionChatPromptSource = 'default' | 'custom';

export interface CollectionChatPromptResponse {
  prompt: string;
  source: CollectionChatPromptSource;
  prompt_id?: string | null;
}

export interface CollectionChatPromptError {
  detail: string;
}

export const getCollectionChatSystemPrompt = async (
  orgId: string,
  collectionId: string,
): Promise<CollectionChatPromptResponse | CollectionChatPromptError> => {
  const response = await apiRequest<CollectionChatPromptResponse>({
    url: `/collections/${orgId}/${collectionId}/chat/system-prompt`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    return { detail: response.detail || 'Failed to load chat prompt.' };
  }

  if (!response?.data) {
    return { detail: 'Chat prompt response was empty.' };
  }

  return response.data;
};
